// extracted by mini-css-extract-plugin
export default {"container":"tUcoVV","small":"yKidsd","medium":"sBHNAS","big":"DZVJza","extraBig":"Uso3jQ","inlineFlex":"dPE0EQ"};